import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';
import FormLine from 'src/components/ui/FormLine';
import TextField from 'src/components/ui/TextField';
import Autocomplete from 'src/components/ui/Autocomplete';
import Datepicker from 'src/components/ui/DatePicker';
import StatusField from 'src/components/ui/StatusField';
import GroupEdit from '../GroupEdit/GroupEdit';
import IconActions from 'src/components/ui/IconActions';
import ServerErrorAlert from 'src/components/ui/ServerErrorAlert';
import { useMemo } from 'react';

const EventForm = (props) => {
	const {
		comment,
		status,
		statusReason,
		statusDate,
		withStatusReason = false,
		withStatusDate = false,
		actions = [],
		groups = [],
		submitLabel,
		cancelLabel,
		onEdit,
		onAction,
		onSubmit,
		isSubmitting = false,
		submitError,
		cancelHandler = () => {},
	} = props;

	const isGroupsEmpty = useMemo(() => {
		return (
			groups.length < 0 ||
			groups.every((group) => group.typos.length === 0)
		);
	}, [groups]);

	return (
		<Card>
			<CardContent>
				<Stack spacing={4}>
					{comment && (
						<FormLine
							type={FORM_LINE_TYPES.textfield}
							params={comment}
						/>
					)}
					{status && (
						<StatusField
							label={status.label}
							withDate={withStatusDate}
							withReason={withStatusReason}
							status={{
								...status,
								label: undefined,
							}}
							date={statusDate}
							reason={statusReason}
						/>
					)}
					{!isGroupsEmpty && (
						<Stack spacing={2}>
							{groups.map((group, index) => {
								if (!group.typos.length) return;

								return (
									<GroupEdit
										key={index}
										onDelete={group.onDelete}
										onEdit={onEdit}
										{...group}
									/>
								);
							})}
						</Stack>
					)}
				</Stack>
			</CardContent>
			<Stack p={2} spacing={2}>
				{actions && (
					<Box
						sx={{
							pt: 1,
							borderTop: '1px solid',
							borderColor: 'divider',
						}}
					>
						<IconActions {...actions} onAction={onAction} />
					</Box>
				)}
				<Stack direction="row" spacing={2}>
					{submitLabel && (
						<Button
							variant="contained"
							onClick={onSubmit}
							disabled={isSubmitting}
						>
							{submitLabel}
						</Button>
					)}
					{cancelLabel && (
						<Button
							variant="outlined"
							color="secondary"
							onClick={cancelHandler}
							disabled={isSubmitting}
						>
							{cancelLabel}
						</Button>
					)}
				</Stack>
				{submitError && (
					<Box px={2} pb={1}>
						<ServerErrorAlert error={submitError} />
					</Box>
				)}
			</Stack>
		</Card>
	);
};

EventForm.propTypes = {
	comment: PropTypes.shape(TextField.propTypes),
	status: PropTypes.shape(Autocomplete.propTypes),
	statusReason: PropTypes.shape(Autocomplete.propTypes),
	statusDate: PropTypes.shape(Datepicker.propTypes),
	withStatusReason: PropTypes.bool,
	withStatusDate: PropTypes.bool,
	actions: PropTypes.shape(IconActions.propTypes),
	groups: PropTypes.arrayOf(PropTypes.shape(GroupEdit.propTypes)),
	submitLabel: PropTypes.string,
	cancelLabel: PropTypes.string,
	onSubmit: PropTypes.func,
	isSubmitting: PropTypes.bool,
	submitError: ServerErrorAlert.propTypes.error,
	onDelete: PropTypes.func,
	onEdit: PropTypes.func,
	onAction: PropTypes.func,
	cancelHandler: PropTypes.func,
};
export default EventForm;
